// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';

export async function deleteDraftInvoice(invoiceKey: string) {
  await api.post(`/v1/invoice/${invoiceKey}/delete`);
}
